import { createContext, useEffect, useState } from "react";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

const fpPromise = FingerprintJS.load();

export const FingerprintContext = createContext("");

const FingerprintProvider = ({ children }) => {
  const [fingerprint, setFingerprint] = useState();
  useEffect(() => {
    fpPromise
      .then((fp) => fp.get())
      .then((result) => {
        setFingerprint(result.visitorId);
      });
  }, []);

  return (
    <FingerprintContext.Provider value={fingerprint}>
      {children}
    </FingerprintContext.Provider>
  );
};

export default FingerprintProvider;
